/**
 * Yvine Design — gallery lightbox.
 * Cached asset, initialised once per [data-art="gallery"] element by art-core.js
 * (first paint, every in-place page swap, theme-editor reloads).
 */
Art.section('gallery', function (root) {
    // ---- Collection rail: filter + search ----------------------------
    // Runs before the lightbox wiring and independently of it, so a gallery
    // with no lightbox in the DOM is still filterable.
    //
    // ONE list drives both shapes. On desktop the <dialog> is simply on the
    // page as a column (CSS overrides the UA's display:none for a closed
    // dialog) and nothing here opens or closes it. On a phone the same element
    // is opened with showModal(), which lifts it into the top layer — the
    // backdrop-filter on .page-wrapper would otherwise make it the containing
    // block for a fixed sheet and strand it at the foot of the page.
    (function rail() {
      var list = root.querySelector('[data-rail-list]');
      if (!list) return; // one collection only — the section renders no rail

      var panel = root.querySelector('[data-rail]');
      var trigger = root.querySelector('[data-rail-trigger]');
      var closeBtn = root.querySelector('[data-rail-close]');
      var search = root.querySelector('[data-rail-search]');
      var bar = root.querySelector('[data-rail-bar]');
      var searchBox = root.querySelector('[data-rail-search-box]');
      var searchClear = root.querySelector('[data-rail-search-clear]');
      var filterToggle = root.querySelector('[data-rail-filter-toggle]');
      var current = root.querySelector('[data-rail-current]');
      var currentDot = root.querySelector('[data-rail-current-dot]');
      var currentCount = root.querySelector('[data-rail-current-count]');
      var noResults = root.querySelector('[data-gal-noresults]');
      var strips = Array.prototype.slice.call(root.querySelectorAll('[data-gal-strip]'));
      var layoutTimer = null;
      var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-gal-item]'));
      var bands = Array.prototype.slice.call(root.querySelectorAll('[data-gal-band]'));
      var coll = '';

      // ---- Blur-up ---------------------------------------------------
      // Each tile holds a 20px copy of its own picture, blurred, behind the
      // real one. A tile is only put into that state if its picture has NOT
      // already arrived — a cached image must not blur and then re-appear.
      // The placeholder URL is held in data-ph, not in a style attribute: a
      // CSS background is fetched for EVERY tile as soon as it is painted,
      // which meant 40-odd requests on load for pieces nobody had scrolled to
      // yet. It is now attached when the tile comes near the viewport, on the
      // same approach as the lazy image it stands in for.
      function armTile(tile) {
        var pic = tile.querySelector('img');
        if (!pic || tile.dataset.armed) return;
        tile.dataset.armed = '1';
        if (pic.complete && pic.naturalWidth > 0) { tile.classList.add('is-loaded'); return; }
        var ph = tile.getAttribute('data-ph');
        if (ph) tile.style.setProperty('--art-ph', "url('" + ph + "')");
        tile.classList.add('is-blurup');
        function done() { tile.classList.add('is-loaded'); }
        pic.addEventListener('load', done, { once: true });
        // A picture that fails still has to stop hiding behind the blur.
        pic.addEventListener('error', done, { once: true });
      }

      if ('IntersectionObserver' in window) {
        var tileObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            armTile(e.target);
            tileObs.unobserve(e.target);
          });
        }, { rootMargin: '600px' });
        tiles.forEach(function (t) { tileObs.observe(t); });
      } else {
        tiles.forEach(armTile);
      }

      // Counts come from the tiles on the page, not from the collection size:
      // a band stops at "Max pieces" and skips pieces with no image, so a
      // Liquid count would promise more than the wall shows.
      list.querySelectorAll('[data-coll]').forEach(function (b) {
        var slot = b.querySelector('[data-rail-count]');
        if (!slot) return;
        var want = b.getAttribute('data-coll') || '';
        slot.textContent = want
          ? tiles.filter(function (t) { return t.getAttribute('data-coll') === want; }).length
          : tiles.length;
      });

      // The sheet only exists where the trigger is laid out; ask the
      // stylesheet rather than repeat the breakpoint here.
      function isSheet() {
        return !!trigger && trigger.offsetParent !== null;
      }

      // ONE field, two homes. On a phone it belongs on the sticky bar, outside
      // the sheet: typed there, the wall it is filtering stays on screen, and
      // the words are still readable once the sheet is shut. On desktop it
      // belongs under the list, inside the docked rail. Moving the node is how
      // the header already handles the app nav; a second copy of the field
      // would be two things to keep in step.
      function placeSearch() {
        if (!searchBox) return;
        var home = isSheet() ? bar : panel;
        if (home && searchBox.parentNode !== home) home.appendChild(searchBox);
      }

      // Shut, the filter is just its icon. It opens on demand, and stays open
      // for as long as there is something typed in it — the words ARE the
      // statement that the wall is filtered.
      function setFilterOpen(on) {
        if (!bar) return;
        // Guarded: apply() calls this on every keystroke while something is
        // typed, and re-focusing a field mid-word is not free.
        if (bar.classList.contains('is-filtering') === on) return;
        bar.classList.toggle('is-filtering', on);
        if (filterToggle) filterToggle.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (on && search) search.focus();
      }

      function openSheet() {
        if (!panel || !panel.showModal || panel.open) return;
        panel.showModal();
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        // showModal makes the rest inert, but iOS still scrolls the page
        // behind a fixed sheet.
        document.documentElement.style.overflow = 'hidden';
      }

      function closeSheet() {
        if (panel && panel.open) panel.close(); // 'close' does the tidying
      }

      function query() { return search ? search.value.trim().toLowerCase() : ''; }
      function tileMatch(tile) {
        var q = query();
        return (!coll || tile.getAttribute('data-coll') === coll) &&
          (!q || (tile.getAttribute('data-search') || '').indexOf(q) !== -1);
      }
      function bandMatch(band) {
        return Array.prototype.some.call(band.querySelectorAll('[data-gal-item]'), tileMatch);
      }

      // Instant: typing in the filter box, where every keystroke must land now.
      function apply(push) {
        tiles.forEach(function (tile) { tile.hidden = !tileMatch(tile); });
        layout(push);
      }

      // Piece by piece (Art.filterItems): pieces that leave fade away, whole
      // bands with them; the wall switches layout while they are gone (bands
      // to masonry or back) and jumps to the top; the pieces that stay glide
      // from where they were on screen to their new places; arrivals fade in.
      function applyAnimated(push, toTop) {
        if (!(window.Art && Art.filterItems)) { apply(push); if (toTop && window.Art) Art.jumpTo(); return; }
        Art.filterItems(tiles, tileMatch, {
          container: root.querySelector('.art-rail-layout__content'),
          glide: 'clone', // the masonry is CSS columns: see Art.filterItems
          groups: bands,
          groupMatches: bandMatch,
          change: function () { layout(push); if (toTop) Art.jumpTo(); }
        });
      }

      function layout(push) {
        var q = query();
        var shown = tiles.filter(function (t) { return !t.hidden; }).length;

        // A band whose pieces are all filtered out hides its heading too,
        // otherwise the page is a column of titles with nothing under them.
        bands.forEach(function (band) {
          band.hidden = !band.querySelector('[data-gal-item]:not([hidden])');
        });

        if (noResults) noResults.hidden = shown !== 0;

        // Browsing every collection = each one is two rows that run sideways,
        // so the whole wall is reachable by scrolling the page once. Opening
        // one collection (or searching) = the full masonry, because then the
        // pieces on screen ARE what you asked for.
        var expanded = !!coll || !!q;
        strips.forEach(function (strip) {
          strip.classList.toggle('is-expanded', expanded);
          // The same flag on the wrapper, so the stylesheet can tell a still
          // grid from a sideways band without depending on :has() matching.
          var wrap = strip.closest('.art-strip-wrap');
          if (wrap) wrap.classList.toggle('is-expanded', expanded);
          if (expanded) strip.scrollLeft = 0;
        });
        if (window.ArtStrip) {
          window.ArtStrip.layoutAll(root);
          strips.forEach(window.ArtStrip.syncArrows);
        }

        var activeLabel = '';
        var activeCount = '';
        var activeDot = null;
        list.querySelectorAll('[data-coll]').forEach(function (b) {
          var on = (b.getAttribute('data-coll') || '') === coll;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on) {
            var name = b.querySelector('.art-rail__name');
            var count = b.querySelector('[data-rail-count]');
            activeLabel = name ? name.textContent.trim() : '';
            activeCount = count ? count.textContent.trim() : '';
            activeDot = b.querySelector('.art-dot');
          }
        });

        // The phone's one sticky line has to say where you are, since the list
        // it came from is no longer on screen.
        if (current && activeLabel) current.textContent = activeLabel;
        if (currentCount) currentCount.textContent = activeCount;

        // The phone's one line carries the chosen collection's colour too, so
        // the colour is the thing you recognise even with the list closed.
        if (currentDot) {
          var colour = activeDot ? activeDot.style.getPropertyValue('--art-dot') : '';
          currentDot.style.setProperty('--art-dot', colour);
          currentDot.classList.toggle('art-dot--set', !!colour);
          currentDot.classList.toggle('art-dot--blank', !coll);
        }
        if (trigger) trigger.classList.toggle('is-filtered', !!coll || !!q);
        // Shut, the icon still has to say something is typed behind it.
        if (filterToggle) filterToggle.classList.toggle('is-filtered', !!q);
        if (searchClear) searchClear.hidden = !q;
        // Filtered = the field stays on show, sheet open or shut.
        if (q) setFilterOpen(true);

        if (push) {
          var url = coll
            ? window.location.pathname + '?c=' + encodeURIComponent(coll)
            : window.location.pathname;
          history.pushState({ artRailColl: coll }, '', url);
        }
      }

      // Bands: layout, arrows, drag and drift all live in the shared
      // ArtStrip (assets/art-strip.js) — the Shop runs the same code.
      // Belt and braces on ordering: art-core boots a section the instant it
      // registers, so if this ever runs before the module is parsed, wait.
      if (window.ArtStrip) window.ArtStrip.init(root);
      else document.addEventListener('DOMContentLoaded', function () {
        if (window.ArtStrip) window.ArtStrip.init(root);
      });

      function collFromUrl() {
        var m = window.location.search.match(/[?&]c=([^&]+)/);
        return m ? decodeURIComponent(m[1]) : '';
      }

      // Picking a collection: piece by piece (applyAnimated), starting at the
      // top of it. The rail itself stays put, like the header on a page
      // change, and marks the choice at once so the click feels heard.
      function choose(value) {
        coll = value;
        list.querySelectorAll('[data-coll]').forEach(function (b) {
          b.classList.toggle('is-active', (b.getAttribute('data-coll') || '') === coll);
        });
        applyAnimated(true, true);
      }

      list.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-coll]');
        if (!btn) return;
        closeSheet(); // picking one is the whole reason the sheet was open
        choose(btn.getAttribute('data-coll') || '');
      });

      // A band's heading does the same as its row in the rail. Handled here,
      // before art-transitions.js sees the link, so it filters in place
      // instead of loading the page again.
      root.addEventListener('click', function (e) {
        var a = e.target.closest('[data-gal-open]');
        if (!a || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        choose(a.getAttribute('data-gal-open') || '');
      });

      if (trigger) {
        trigger.addEventListener('click', function () {
          if (panel && panel.open) closeSheet();
          else openSheet();
        });
      }
      if (closeBtn) closeBtn.addEventListener('click', closeSheet);
      if (filterToggle && bar) {
        filterToggle.addEventListener('click', function () {
          setFilterOpen(!bar.classList.contains('is-filtering'));
        });
      }
      // One tap drops the filter and folds the field away with it.
      if (searchClear && search) {
        searchClear.addEventListener('click', function () {
          search.value = '';
          apply(false);
          setFilterOpen(false);
        });
      }

      if (panel) {
        panel.addEventListener('close', function () {
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          document.documentElement.style.overflow = '';
          // preventScroll: handing focus back must not undo the jump to top.
          if (isSheet() && trigger) trigger.focus({ preventScroll: true });
        });
        // The dialog box is the only thing inside the dialog element that
        // receives clicks, so a click on the element itself is the backdrop.
        panel.addEventListener('click', function (e) {
          if (e.target === panel) closeSheet();
        });
      }

      if (search) {
        search.addEventListener('input', function () { apply(false); });
        // Esc clears the box first; only an empty box lets the sheet close.
        search.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && search.value) {
            e.stopPropagation();
            e.preventDefault();
            search.value = '';
            apply(false);
          } else if (e.key === 'Enter') {
            // Nothing to submit — the wall is already filtered. Enter just
            // means "done typing": drop the keyboard and, if the list happens
            // to be open over it, get that out of the way too.
            e.preventDefault();
            search.blur();
            closeSheet();
          }
        });
      }

      // On window, so it outlives its own markup; it retires once the section
      // it belongs to has been swapped out, rather than filtering a wall that
      // is no longer on the page.
      window.addEventListener('popstate', function onPop() {
        if (!document.contains(root)) { window.removeEventListener('popstate', onPop); return; }
        coll = collFromUrl();
        applyAnimated(false, false);
      });

      // Rotating to landscape can put the rail back on the page while the
      // dialog is still open; close it rather than strand a scroll lock.
      window.addEventListener('resize', function onResize() {
        if (!document.contains(root)) { window.removeEventListener('resize', onResize); return; }
        if (panel && panel.open && !isSheet()) closeSheet();
        placeSearch();
      }, { passive: true });

      placeSearch();

      // Runs once on load even with no ?c=: this is what fills the counts and
      // the trigger's label. A ?c= link (shared, or Back) opens on that one.
      coll = collFromUrl();
      apply(false);
    })();

    // ---- The intro, one line on a phone -------------------------------
    // The caret is only worth a place when the line is genuinely cut short, so
    // it is hidden until the paragraph is measured and found to overflow. All
    // of the collapsing itself is CSS; this only decides whether to offer it.
    (function intro() {
      var wrap = root.querySelector('[data-gal-intro]');
      if (!wrap) return;
      var text = wrap.querySelector('[data-gal-intro-text]');
      var btn = wrap.querySelector('[data-gal-intro-toggle]');
      if (!text || !btn) return;

      function sync() {
        // Measuring it open says nothing about whether it needs to collapse.
        if (wrap.classList.contains('is-open')) return;
        btn.hidden = text.scrollWidth <= text.clientWidth + 1;
      }

      // The caret stays the real control (a button, focusable, announced);
      // tapping the line is the same action for a thumb. Both do nothing when
      // the caret is not offered — desktop, or an intro short enough to fit.
      function toggle() {
        if (btn.hidden) return;
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      btn.addEventListener('click', toggle);
      text.addEventListener('click', toggle);

      var t = null;
      window.addEventListener('resize', function onResize() {
        if (!document.contains(root)) { window.removeEventListener('resize', onResize); return; }
        window.clearTimeout(t);
        t = window.setTimeout(sync, 150);
      }, { passive: true });

      sync();
      // The brand fonts arrive after first paint and change where the line
      // breaks, so measure again once they have.
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
      else window.addEventListener('load', sync);
    })();

    // ---- Quick view -------------------------------------------------
    // Hovering a piece that holds more than one item slides its other media
    // out on a row. The row lives on <body>, not in the band: the band is a
    // scroll container and clips what it holds, so a row that spills past the
    // piece has to be outside it. Mouse only — a touch screen has no hover,
    // and the corner stack already says there is more behind.
    var quick = (function () {
        var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
        if (!fine.matches) return null;

        var el = document.querySelector('.art-quickview');
        if (!el) {
          el = document.createElement('div');
          el.className = 'art-quickview';
          el.hidden = true;
          document.body.appendChild(el);
        }
        var openFor = null, showTimer = null, hideTimer = null;

        var heldStrip = null;
        function release() {
          if (heldStrip && heldStrip.__artHold) heldStrip.__artHold(false);
          heldStrip = null;
        }
        function hide() {
          window.clearTimeout(showTimer);
          el.classList.remove('is-open');
          openFor = null;
          release();
          hideTimer = window.setTimeout(function () { el.hidden = true; }, 180);
        }

        function place(tile) {
          var t = tile.getBoundingClientRect();
          // The collage is where this panel belongs, so that is where it grows
          // from and what the wedge points back at.
          var stack = tile.querySelector('.art-gal__stack');
          var sr = stack ? stack.getBoundingClientRect() : null;
          var originX = sr ? sr.left + sr.width / 2 : t.left + t.width / 2;

          el.hidden = false;
          var w = el.offsetWidth, h = el.offsetHeight, m = 10;
          var left = Math.round(t.left + t.width / 2 - w / 2);
          left = Math.max(m, Math.min(left, window.innerWidth - w - m));

          var below = true;
          var top = Math.round(t.bottom + 12);
          if (top + h + m > window.innerHeight) { below = false; top = Math.round(t.top - h - 12); }
          if (top < m) { top = m; below = true; }

          el.style.left = left + 'px';
          el.style.top = top + 'px';
          el.classList.toggle('is-above', !below);

          // Where the panel grows from, in its own coordinates.
          var relX = Math.max(16, Math.min(originX - left, w - 16));
          el.style.setProperty('--qv-origin-x', relX + 'px');
          el.style.setProperty('--qv-origin-y', (below ? 0 : h) + 'px');
        }

        function build(tile) {
          var kinds = (tile.getAttribute('data-media-kinds') || '').split(',').filter(Boolean);
          var urls = (tile.getAttribute('data-media-urls') || '').split(',').filter(Boolean);
          var thumbs = (tile.getAttribute('data-media-thumbs') || '').split(',').filter(Boolean);
          if (urls.length < 2) return false;
          el.textContent = '';
          urls.forEach(function (u, n) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'art-quickview__item' + (kinds[n] === 'video' ? ' art-quickview__item--video' : '');
            var im = document.createElement('img');
            im.src = thumbs[n] || u; im.alt = ''; im.loading = 'lazy'; im.decoding = 'async';
            b.appendChild(im);
            b.addEventListener('click', function (e) {
              e.stopPropagation();
              hide();
              openLightbox(tile, n);
            });
            el.appendChild(b);
          });

          // Roll out from the middle to both sides: each one starts stacked
          // on the centre and travels to its place, the nearest leaving first.
          var mid = (urls.length - 1) / 2;
          Array.prototype.forEach.call(el.children, function (b, n) {
            var away = n - mid;                       // negative = left side
            var step = Math.abs(away);
            b.style.setProperty('--qv-dx', Math.round(-away * 34) + 'px');
            b.style.setProperty('--qv-rot', (away < 0 ? 9 : -9) + 'deg');
            b.style.setProperty('--qv-delay', Math.round(step * 52) + 'ms');
          });
          return true;
        }

        function show(tile) {
          window.clearTimeout(hideTimer);
          if (openFor === tile) return;
          // build() replaces every thumbnail, so nothing carries over from the
          // piece before; the panel itself is reset just below.
          if (!build(tile)) return;
          openFor = tile;
          release();
          heldStrip = tile.closest('[data-gal-strip]');
          if (heldStrip && heldStrip.__artHold) heldStrip.__artHold(true);
          // A genuine restart. The panel is reused between pieces, so moving
          // from one to the next found it already open, with nothing to
          // animate from — it animated the first time and popped after that.
          // Taking it out of the layout and putting it back is what makes the
          // browser treat the closed state as a real starting point; removing
          // a class and forcing a reflow did not reliably do it.
          el.hidden = true;
          el.classList.remove('is-open');
          // Cancel anything still running. Moving to a new piece while the
          // last panel was still fading left those transitions in flight, and
          // the new one started from wherever they had got to — which is why
          // it sometimes appeared fully formed instead of growing.
          if (el.getAnimations) {
            el.getAnimations().forEach(function (a) { a.cancel(); });
            el.querySelectorAll('*').forEach(function (node) {
              if (node.getAnimations) node.getAnimations().forEach(function (a) { a.cancel(); });
            });
          }
          void el.offsetWidth;
          // Placed twice: its width is not known until the thumbnails are in
          // it, and the wedge and the growth origin are both measured from
          // that width. place() puts it back into the layout.
          place(tile);
          place(tile);
          void el.offsetWidth;          // commit the closed state at that size
          el.classList.add('is-open');
        }

        el.addEventListener('pointerenter', function () { window.clearTimeout(hideTimer); });
        el.addEventListener('pointerleave', hide);
        // Follow the piece rather than disappear. The band drifts, which fires
        // a scroll event every frame — hiding on scroll meant the row was gone
        // the instant it appeared on any band that was moving.
        window.addEventListener('scroll', function () {
          if (!openFor) return;
          var t = openFor.getBoundingClientRect();
          if (t.bottom < 0 || t.top > window.innerHeight || t.right < 0 || t.left > window.innerWidth) hide();
          else place(openFor);
        }, { passive: true, capture: true });

        return {
          enter: function (tile) {
            // Cancel the pending hide from the piece we just left, TOO.
            // Leaving one piece scheduled hide() in 120ms, and hide() cancels
            // whatever show is pending — so moving straight onto the next
            // piece armed a show and then had it cancelled out from under it.
            // Every other hover appeared to do nothing.
            window.clearTimeout(hideTimer);
            window.clearTimeout(showTimer);
            showTimer = window.setTimeout(function () { show(tile); }, 260);
          },
          leave: function () {
            window.clearTimeout(showTimer);
            hideTimer = window.setTimeout(hide, 120);
          },
          hide: hide
        };
      })();

    // Open the one shared lightbox with this piece's media (images AND
    // videos, in her order). The gallery no longer owns a lightbox.
    function openLightbox(tile, start) {
      if (!window.ArtLightbox) return;
      var kinds = (tile.getAttribute('data-media-kinds') || '').split(',').filter(Boolean);
      var urls = (tile.getAttribute('data-media-urls') || '').split(',').filter(Boolean);
      var thumbUrls = (tile.getAttribute('data-media-thumbs') || '').split(',').filter(Boolean);
      var list = urls.map(function (u, n) {
        return { kind: kinds[n] || 'image', url: u, thumb: thumbUrls[n] || u };
      });
      if (!list.length) {
        var only = tile.getAttribute('data-full');
        if (only) list = [{ kind: 'image', url: only, thumb: only }];
      }
      window.ArtLightbox.open({
        media: list,
        start: start || 0,
        title: tile.getAttribute('data-title') || '',
        meta: tile.getAttribute('data-meta') || '',
        price: tile.getAttribute('data-price') || '',
        description: tile.getAttribute('data-desc') || '',
        ctaLabel: tile.getAttribute('data-cta-label') || '',
        ctaUrl: tile.getAttribute('data-cta-url') || ''
      });
    }

    root.querySelectorAll('[data-gal-item]').forEach(function (tile) {
      tile.addEventListener('click', function () {
        if (quick) quick.hide();
        openLightbox(tile, 0);
      });
      if (quick && (tile.getAttribute('data-media-urls') || '').split(',').filter(Boolean).length > 1) {
        tile.addEventListener('pointerenter', function () { quick.enter(tile); });
        tile.addEventListener('pointerleave', function () { quick.leave(); });
      }
    });
});
